module.exports = __webpack_public_path__ + "static/main_01-0456047aa429adc52536f578f7cb7f41.png";